import { CloseIcon } from "components/SVG"
import React, { useCallback, useState, useEffect } from "react"
import type { FilterInputType } from "./types"
import {
  clearButton,
  activeFilterButton,
  filterOverviewWrapper,
  filterButtonIcon,
  clearAllButton,
} from "./PLPFilters.css"
import { colours } from "@shared/ui.design-system"

type Props = {
  activeFilters: FilterInputType[]
  onRemoveAllFilters: () => void
}

export const PLPFiltersOverview: React.FC<Props> = ({
  activeFilters,
  onRemoveAllFilters,
}) => {
  const [filterState, setFilterState] =
    useState<FilterInputType[]>(activeFilters)

  const removeFilter = useCallback(
    (input: FilterInputType) => {
      const filterIndex = filterState.findIndex(
        (item) =>
          item.slug === input.slug && item.subCategory === input.subCategory
      )

      const filtersCopy = [...filterState]
      filtersCopy.splice(filterIndex, 1)
      setFilterState(filtersCopy)
    },
    [filterState]
  )

  const removeAllFilters = () => {
    setFilterState([])
    onRemoveAllFilters()

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has("filters")) urlParams.delete("filters")
    window.location.search = urlParams.toString()
  }

  useEffect(() => {
    setFilterState(activeFilters)
  }, [activeFilters])

  return (
    <div className={filterOverviewWrapper}>
      {filterState.map((item, index) => {
        const key = `keyword-${item.slug}-${index}`
        return (
          <button
            type="button"
            className={activeFilterButton}
            key={key}
            onClick={() => removeFilter(item)}
            color={colours.secondary.light}
          >
            {item.label}{" "}
            <CloseIcon
              fill="#fff"
              height="16"
              width="16"
              className={filterButtonIcon}
            />
          </button>
        )
      })}
      <button
        type="button"
        className={clearAllButton}
        onClick={removeAllFilters}
      >
        <span className={clearButton}>Clear All</span>
      </button>
    </div>
  )
}
